<template>
  <v-container style="max-width: 100%">
    <v-data-table
      :headers="headersOrganisations"
      :items="organisationsWithMeta"
      sort="name"
      :items-per-page="-1"
      disable-pagination
      hide-default-footer
      :search="searchOrganisations"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-card
            flat
            style="width: 100%"
          >
            <v-card
              flat
              class="d-flex flex-row flex-wrap"
            >
              <v-toolbar-title>Organisations</v-toolbar-title>
              <v-spacer />
              <v-card
                flat
                style="width: 300px"
              >
                <v-text-field
                  v-model="searchOrganisations"
                  append-icon="$vuetify.icons.icon_mdi_magnify"
                  :label="'Search ' + `${ organisationsWithMeta.length }` + ' organisation(s)'"
                  single-line
                  hide-details
                  clearable
                />
              </v-card>
              <v-spacer />
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="ppc_pink"
                    dark
                    small
                    absolute
                    right
                    fab
                    @click="newOrganisation()"
                    v-on="on"
                  >
                    <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
                  </v-btn>
                </template>
                <span>new contact</span>
              </v-tooltip>
            </v-card>
          </v-card>
        </v-toolbar>
      </template>
      <template v-slot:[`item.obsolete`]="{ item }">
        <v-icon
          v-if="item.obsolete !== null"
          small
          color="ppc_pink"
        >
          $vuetify.icons.icon_mdi_cancel
        </v-icon>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          $vuetify.icons.icon_mdi_pencil
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)"
        >
          $vuetify.icons.icon_mdi_delete
        </v-icon>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialogEditOrganisation"
      max-width="700px"
      persistent
    >
      <v-form ref="dialogForm">
        <v-card>
          <v-card-title class="ppc_darkgreen darken-1">
            <span class="headline white--text"> {{ formTitle }} {{ editedItem.name }} </span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                md="8"
              >
                <v-text-field
                  v-model.trim="editedItem.name"
                  label="Name"
                  prepend-icon="$vuetify.icons.icon_mdi_smart_card ppc_darkgreen--text"
                  counter="45"
                  clearable
                  :rules="inputRulesName"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model.trim="editedItem.address"
                  label="address"
                  prepend-icon="$vuetify.icons.icon_mdi_map_marker"
                  clearable
                  counter="100"
                />
              </v-col>
              <v-col
                cols="auto"
                sm="6"
              >
                <v-select
                  v-model="editedItem.country_id"
                  :items="$store.state.itemsNationality"
                  item-text="nationality"
                  item-value="id"
                  :menu-props="{ auto: true }"
                  label="Select country"
                  single-line
                  prepend-icon="mdi-earth ppc_darkgreen--text"
                  validate-on-blur
                  clearable
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model.trim="editedItem.phone"
                  label="phone"
                  prepend-icon="mdi-cellphone ppc_darkgreen--text"
                  :rules="inputRulesPhone"
                  clearable
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model.trim="editedItem.email"
                  prepend-icon="mdi-email ppc_darkgreen--text"
                  label="email"
                  clearable
                  :rules="inputRulesEmail"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                class="d-flex flex-row flex-wrap py-0 my-0"
              >
                <v-textarea
                  v-model="editedItem.comments"
                  class="rounded-xl ma-3"
                  auto-grow
                  clearable
                  counter="255"
                  outlined
                  label="Comments (255 max)"
                  :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
                class="d-flex flex-row flex-wrap py-0 my-0"
              >
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="ppc_pink"
                      fab
                      dark
                      x-small
                      bottom
                      class="mb-3"
                      @click="dialogSelectContacts = true"
                      v-on="on"
                    >
                      <v-icon color="white">
                        mdi-plus
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>add contact</span>
                </v-tooltip>
                <v-card
                  flat
                  class="d-flex flex-column"
                >
                  <v-data-table
                    :headers="headersConnectedContacts"
                    :items="connectedContacts"
                    class="ma-4"
                    disable-pagination
                    hide-default-footer
                    dense
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon
                        small
                        @click="deleteConnectedContact(item)"
                      >
                        $vuetify.icons.icon_mdi_delete
                      </v-icon>
                    </template>
                    <template v-slot:[`item.country_id`]="{ item }">
                      {{ nationalityById.get(item.country_id) || '—' }}
                    </template>
                  </v-data-table>
                  <v-divider />
                </v-card>
              </v-col>

              <v-col
                cols="12"
                class="d-flex flex-row flex-wrap py-0 my-0"
              >
                <v-col 
                  cols="12"
                  sm="6"
                  md="4"
                  class="py-0 my-0"
                >
                  <v-checkbox
                    :input-value="editedItem.obsolete !== null"
                    label="Obsolete"
                    @change="setObsolete($event)"
                  />
                </v-col>
                <v-col 
                  cols="12"
                  sm="6"
                  md="4"
                  class="py-0 my-0"
                >
                  <v-text-field
                    v-if="editedItem.obsolete !== null"
                    :value="formattedDate(editedItem.obsolete)"
                    disabled
                    label="From"
                    class="ml-2"
                  />
                </v-col>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="ppc_darkgreen darken-1"
              text
              @click="closeDialogEditOrganisation"
            >
              Cancel
            </v-btn>
            <v-btn
              color="ppc_darkgreen darken-1"
              text
              @click="saveOrganisation"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="dialogDelete"
      max-width="500px"
    >
      <v-card>
        <v-card-title>Are you sure you want to delete {{ editedItem.name }}?</v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="closeDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="deleteItemConfirm"
          >
            OK
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogSelectContacts"
      :retain-focus="false"
      max-width="320px"
    >
      <v-card>
        <v-card-title class="d-flex flex-row flex-wrap">
          <span>Select Contact</span>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0">
          <v-list rounded>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="co in activeContacts"
                :key="co.id"
                dense
                @click="addContacts(co)"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ co.full_name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ nationalityById.get(co.country_id) || '—' }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="dialogSelectContacts = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import inputRules from '../mixins/inputRules';
import formattedDate from '../mixins/formattedDate';
import dayjs from 'dayjs';

export default {

    mixins: [inputRules, formattedDate],
    data: () => ({
        dialogEditOrganisation: false,
        dialogDelete: false,
        dialogSelectContacts: false,
        headersOrganisations: [
            {
            text: 'Name',
            align: 'start',
            value: 'name',
            width: '25ch',
            },
            { text: 'Contact(s)', value: 'contacts', width: '500px' },
            // { text: 'Client Agency', value: 'agencies'},
            { text: 'Role', value: 'role'},
            { text: 'Comments', value: 'comments' },
            { text: 'Obs', value: 'obsolete'},
            { text: 'Actions', value: 'actions', sortable: false, width: '200px' },
        ],
        headersConnectedContacts: [
            { text: 'Contact', value: 'full_name' },
            { text: 'Actions', value: 'actions', sortable: false, width: '200px' },
        ],
        isNew: true,
        editedItem: {
            name: '',
        },
        defaultItem: {
            name: '',
        },
        dialogContactInfo: false,
        contact: false,
        searchOrganisations: '',
        pendingContactIds: [],
    }),

    computed: {
        organisationsWithMeta() {
            return this.$store.state.organisations.map(organisation => ({
                ...organisation,
                contacts: this.$store.getters.contactNamesByOrganisation(organisation.id),
                agencies: this.$store.getters
                  .agenciesByOrganisationId(organisation.id)
                  .map(a => a.nameFormal),
                role: this.buildRole(organisation),
            }));
        },

        formTitle () {
            return this.isNew ? 'New Organisation' : 'Edit Organisation';
        },

        connectedContacts() {
            return this.$store.state.contacts
            .filter(co => this.pendingContactIds.includes(co.id));
        },

        activeContacts() {
            return this.$store.state.contacts.filter(co => co.obsolete === null);
        },

        nationalityById() {
            return new Map(
                this.$store.state.itemsNationality.map(c => [c.id, c.nationality])
            );
        },
        
    },

    watch: {
    },

    beforeCreate () {
        this.$store.dispatch('setLoadingApp', 1)
    },

    created () {
        dayjs.locale("en");
        this.initialize()
    },

    methods: {
      async initialize () {
        this.getData();
      },

    async getData() {
        this.$store.dispatch('setLoadingApp', 1);

        await Promise.all([
            this.$store.dispatch('getContacts'),
            this.$store.dispatch('getOrganisations'),
            this.$store.dispatch('getOrganisationContacts'),
        ]);

        this.$store.dispatch('setLoadingApp', 0);
    },

    buildRole(org) {
        const roles = [
            org.agency && 'client agency',
            org.projects && 'project placement',
            org.tours && 'tour agency',
        ];

        return roles.filter(Boolean).join(', ');
    },

    newOrganisation() {
        this.isNew = true;
        this.editedItem = { country_id: 184, obsolete: null };
        this.dialogEditOrganisation = true;
    },

    editItem(item) {
        this.isNew = false;
        this.editedItem = { ...item };

        // initialize pending orgs from current connections
        this.pendingContactIds =
            this.$store.state.organisationsContacts
            .filter(oc => oc.organisation_id === item.id)
            .map(oc => oc.contact_id);

        this.dialogEditOrganisation = true;
    },

    addContacts(co) {
        if (!this.pendingContactIds.includes(co.id)) {
            this.pendingContactIds.push(co.id);
        }

        this.dialogSelectContacts = false;
    },

    deleteConnectedContact(co) {
        this.pendingContactIds =
            this.pendingContactIds.filter(id => id !== co.id);
    },

    deleteItem(item) {
        // work with domain identity, not array index
        this.isNew = false;
        this.editedItem = { ...item };

        const isInUse = [
            'projects',
            'tours',
            'agency',
        ].some(key => Number(this.editedItem[key]) > 0);

        if (isInUse) {
            this.$store.dispatch('errorMessage', 'Organisation is still in use');
            return;
        }

        this.dialogDelete = true;
    },

      async deleteItemConfirm () {
        const response = await this.$store.dispatch('deleteOrganisation', this.editedItem.id);

        if (response?.data?.affectedRows === 1) {
          this.$store.dispatch('successMessage', 'Organisation deleted');
          await this.$store.dispatch('getOrganisations');
        } else {
          this.$store.dispatch('errorMessage', 'Something went wrong');
        }

        this.closeDelete();
      },

      closeDialogEditOrganisation () {
        this.dialogEditOrganisation = false;

        // reset edited item
        this.editedItem = { ...this.defaultItem };

        // clear temporary organisation links (editing buffer)
        this.pendingContactIds = [];

        // reset form validation state if form exists
        if (this.$refs.dialogForm) {
          this.$refs.dialogForm.resetValidation();
        }

        // reset mode
        this.isNew = true;
      },

      closeDelete () {
        this.dialogDelete = false
        this.editedItem = Object.assign({}, this.defaultItem)
      },

      setObsolete(event) {
            if (event) {
                this.editedItem.obsolete = dayjs().format("YYYY-MM-DD")
            } else {
                this.editedItem.obsolete = null
            }
        },

    async saveOrganisation () {
        if (!this.$refs.dialogForm.validate()) return;

        const { name, id } = this.editedItem;

        const normalizedName = (name || '').trim().toLowerCase();

        const duplicate = this.$store.state.organisations.some(org =>
            (org.name || '').trim().toLowerCase() === normalizedName &&
            org.id !== id
        );

        if (duplicate) {
            this.$store.dispatch(
                'errorMessage',
                `The name "${name}" is already in use!`
            );
            return;
        }

        // 1️⃣ Insert / Update organisation
        const response = await this.$store.dispatch('insertOrganisation', this.editedItem);

        // if it was a new organisation, make sure we have the generated id

        console.log(this.editedItem.id, response)
        if (!this.editedItem.id && response?.insertId) {
            this.editedItem.id = response.insertId;
        }

        const organisationId = this.editedItem.id;

        // 2️⃣ Sync organisation links
        // remove existing links first (safe & simple approach)
        await this.$store.dispatch('deleteOrganisationContactsByOrganisation', organisationId);

        // insert selected links
        for (const contactId of this.pendingContactIds) {
            await this.$store.dispatch('insertOrganisationContact', {
                contact_id: contactId,
                organisation_id: organisationId,
            });
        }

        // 3️⃣ Refresh store data
        await this.getData();

        // 4️⃣ Close dialog cleanly
        this.closeDialogEditOrganisation();
    },

        // openOrganisations(item) {
        //     this.$store.dispatch('setLoadingApp', 1)
        //     this.$router.push({ name: 'Organisations', params: { organisationId: item.id } })
        // },
    },
  }

</script>

<style>
    .v-card__title {
        color: #35b729;
        word-break: normal !important;
    }
    .v-card__subtitle { padding-top: 0; padding-bottom: 0;}
    .pos_absolute {
        position: absolute;
    }
</style>